<ul [ngClass]="level > 1 ? 'mr-3' : ''">
 <ng-container *ngFor="let item of destinations">
  <li
   class="flex flex-col p-sm text-gray-ds-300 pr-5 hover:bg-transparency-primary-10 hover:text-primary-500 hover:after:bg-primary-500">
   <a [href]="item.Link">
    <div class="flex items-center justify-between text-p">
     <span>هتل های {{ item.Title }}</span>
     <span>({{ item.TotalAccommodations }})</span>
    </div>
   </a>
  </li>
  <iho-recursive-destinations
   *ngIf="item.Destinations?.length"
   [destinations]="item.Destinations"
   [level]="level + 1" />
 </ng-container>
</ul>
